export default {
  ptsi: {
    settings: "Configuración",
    overdueTimeForDdsReport: "Tiempo de Vencimiento del Informe DDS",
    setDefaultDueDateForDdsReport: "Establezca la fecha de vencimiento predeterminada del informe DDS.",
    approvalExpirationPeriod: "Período de Vencimiento de la Aprobación",
    setTheDefaultExpirationPeriodForDdsReportApprovals:
      "Establezca el período de vencimiento predeterminado de las aprobaciones de informes DDS",
    visibilityOfDocument: "Visibilidad del Documento",
    setDefaultSelectionForVisibilityOfDocumentsAttachedOnReport:
      "Establezca la selección predeterminada para la visibilidad de los documentos adjuntos al informe.",
    private: "Privado (Solo Administración de PTSI)",
    privateNaccu: "Privado (Solo Administración de NACCU)",
    visibleOnlyToAdminsHiddenFromAllCooperativesAndUsers:
      "Visible solo para los administradores; oculto para todas las cooperativas y usuarios.",
    cooperativeAndPtsiOnly: "Solo Cooperativa y PTSI",
    cooperativeAndNaccuOnly: "Solo Cooperativa y NACCU",
    visibleOnlyToTheAssignedCooperativeAndPlatformAdministrators:
      "Visible solo para la cooperativa asignada y los administradores de la plataforma.",
    public: "Público",
    visibleToEveryoneIncludingAllUsersAndTheGeneralPublic:
      "Visible para todos, incluidos todos los usuarios y el público en general.",
    saveSettings: "Guardar Configuración",
  },
};
